import React, { useEffect, useState } from "react";
import "./navbar-style.css";
// import pages from '../../data/main-page/innerpages';

function Navbar() {
  const currentPath = window.location.pathname;
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`navbar navbar-expand-lg navbar-dark tc-navbar-style1 nav-style2 section-padding-x ${
        scrolled ? "is-scrolled" : ""
      }`}
    >
      <div className="container-fluid content">
        <a className="navbar-brand" href="/">
          <img src="/home1/assets/img/logo.png" alt="" className="logo" />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0 nav-menu-style1">
            <li className="nav-item">
              <a
                className={`nav-link ${currentPath === "/" ? "active" : ""}`}
                href="/"
              >
                Home
              </a>
            </li>

            <li className="nav-item">
              <a
                className={`nav-link ${
                  currentPath === "/innerpages/about" ? "active" : ""
                }`}
                href="/innerpages/about"
              >
                About
              </a>
            </li>

            <li className="nav-item dropdown">
              <a
                className={`nav-link dropdown-toggle ${
                  currentPath === "/innerpages/services" ||
                  currentPath.startsWith("/innerpages/services/")
                    ? "active"
                    : ""
                }`}
                href="/innerpages/services"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Services
              </a>
              <ul className="dropdown-menu">
                <li>
                  <a
                    className="dropdown-item"
                    href="/innerpages/services/architecture-exterior-design"
                  >
                    Architecture & Exterior Design
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/innerpages/services/interior-design"
                  >
                    Interior Design
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/innerpages/services/furniture-design"
                  >
                    Furniture Design
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/innerpages/services/project-consultation"
                  >
                    Project Consultation
                  </a>
                </li>
              </ul>
            </li>

            <li className="nav-item">
              <a
                className={`nav-link ${
                  currentPath === "/innerpages/blog" ? "active" : ""
                }`}
                href="/innerpages/blog"
              >
                Blog
              </a>
            </li>

            <li className="nav-item">
              <a
                className={`nav-link ${
                  currentPath === "/innerpages/portfolio" ? "active" : ""
                }`}
                href="/innerpages/portfolio"
              >
                Portfolio
              </a>
            </li>

            <li className="nav-item">
              <a
                className={`nav-link ${
                  currentPath === "/innerpages/contact" ? "active" : ""
                }`}
                href="/innerpages/contact"
              >
                Contact
              </a>
            </li>

            {/* <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Pages
              </a>
              <ul className="dropdown-menu">
                {pages.map((item, i) => (
                  <li key={i}>
                    <a className="dropdown-item" href={item.link}>
                      {item.title}
                    </a>
                  </li>
                ))}
              </ul>
            </li> */}
          </ul>

         <div className="nav-side">
  <ul className="nav-social-style1">
    {/* Facebook */}
    <li>
      <a
        href="https://www.facebook.com/share/1CxX2Vsq7p/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
      >
        <i className="fa-brands fa-facebook-f"></i>
      </a>
    </li>

    {/* Instagram */}
    <li>
      <a
        href="https://www.instagram.com/ss.architects.interiors?igsh=eDNzNndzejR2ZjNj"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
      >
        <i className="fa-brands fa-instagram"></i>
      </a>
    </li>

    {/* Threads */}
    <li>
      <a
        href="https://www.threads.com/@ss.architects.interiors"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Threads"
      >
        <i className="fa-brands fa-threads"></i>
      </a>
    </li>

    {/* LinkedIn */}
    <li>
      <a
        href="https://www.linkedin.com/company/ss-architects-interiors/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="LinkedIn"
      >
        <i className="fa-brands fa-linkedin-in"></i>
      </a>
    </li>
  </ul>
</div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;